import React, { Component } from 'react'

import 'katex/dist/katex.min.css';
import TeX from '@matejmazur/react-katex';
import styles from './PascalTriangle.module.css';

export default class PascalElement extends Component {


    calculate = () => {
        let numerator = 1
        let denominator = 1;
        for (let i = this.props.n; i > (this.props.n - this.props.k); i--) {
            numerator *= i;
        }

        for (let j = this.props.k; j > 0; j--) {
            denominator *= j;
        }
        return numerator / denominator;
    };


    render() {
        let display = "";
        let showPlus = false;

        switch (this.props.toggle % 3) {
            case 0:
                display = String.raw`{${this.props.n}\choose${this.props.k}}`;
                break;
            case 1:
                display = String.raw`${this.calculate()}`;
                break;
            case 2:
                const x_exp = (this.props.n - this.props.k);
                const y_exp = this.props.k;
                const x_cof = x_exp > 1 ? String.raw`x^${x_exp}` : String.raw`x`;
                const y_cof = y_exp > 1 ? String.raw`y^${y_exp}` : String.raw`y`;
                const xpart = x_exp != 0 ? String.raw`${x_cof}` : "";
                const ypart = y_exp != 0 ? String.raw`${y_cof}` : "";
                display = String.raw`${this.calculate()}${xpart}${ypart}`;
                showPlus = true;
                break;
        }
        return (
            <div className={styles.Coefficient}>
                <TeX>
                    {display}
                </TeX>
            </div>
        )
    }
}
